import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import PostCard from '../../components/PostCard/PostCard';
import './ThoughtOfTheDay.css';
import { Post } from '../../types/types';

const ThoughtOfTheDay = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef<IntersectionObserver | null>(null);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  const fetchPosts = useCallback(async () => {
    if (!hasMore || loading) return;

    setLoading(true);
    try {
      const response = await axios.get('https://funp7bodgl.execute-api.us-east-1.amazonaws.com/api/posts', {
        params: {
          lastKey: lastKey || undefined,
          limit: 10,
        },
      });

      const newPosts = response.data.posts || [];
      const newLastKey = response.data.lastKey || null;

      setPosts(prevPosts => [...prevPosts, ...newPosts]);
      setLastKey(newLastKey);
      setHasMore(!!newLastKey);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  }, [hasMore, loading, lastKey]);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        fetchPosts();
      }
    });

    if (sentinelRef.current) {
      observer.current.observe(sentinelRef.current);
    }

    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, [fetchPosts, hasMore, loading]);

  return (
    <div className="post-list">
      {posts.map(post => (
        <div key={post.id}>
          <PostCard post={post} />
        </div>
      ))}

      {/* Sentinel div for intersection observer */}
      <div ref={sentinelRef} style={{ height: '1px' }} />

      {loading && <p>Loading...</p>}
    </div>
  );
};

export default ThoughtOfTheDay;
